import React from 'react';
import './style.css';

const Checkmark = () => {
    return (
        <div className="checkmark"></div>
    );
};

export default Checkmark;